<div class="flex flex-col gap-5 text-lightText">
  <div class="flex items-start gap-3">
    <app-checkbox formControlName="communication" class="mt-1" />
    <span class="flex flex-col">
      <span class="font-semibold">Kommunikation</span>
      <span class="text-sm text-gray-600">
        Ich willige ein, dass Toyota meine persönlichen Angaben auch nach Abwicklung meiner Anfrage
        u.a. zur individuellen Kundenberatung und Werbung verarbeitet, wie in Ziff.
        (1) „ZWECK DER VERARBEITUNG: KOMMUNIKATION“ der
        <a
          [href]="legalEntity.consentLink(consentVersion)"
          target="_blank"
          class="cursor-pointer underline"
        >
          vollständigen Einwilligungserklärung
        </a>
        beschrieben.
      </span>
    </span>
  </div>
  <div class="flex items-start gap-3">
    <app-checkbox formControlName="profiling" class="mt-1" />
    <span class="flex flex-col">
      <span class="font-semibold">Erweitertes Kundenprofil</span>
      <span class="text-sm text-gray-600">
        Ich willige ein, dass Toyota meine Daten aus verschiedenen Quellen zusammenführt und ein erweitertes
        Kundenprofil zur Verbesserung des Kundenerlebnisses erstellt. Zudem können meine Daten in pseudonymisierter
        Form an Partner weitergegeben werden, um individuelle Zielgruppen zu bilden. Insoweit stimme ich Ziff. (2)
        „ZWECK DER VERARBEITUNG: ERWEITERTES KUNDENPROFIL“ der
        <a
          [href]="legalEntity.consentLink(consentVersion)"
          target="_blank"
          class="cursor-pointer underline"
        >
          vollständigen Einwilligungserklärung
        </a>
        zu.
      </span>
    </span>
  </div>
  <div class="flex items-start gap-3">
    <app-checkbox formControlName="dataSharing" class="mt-1" />
    <span class="flex flex-col">
      <span class="font-semibold">Datenweitergabe an Toyota-Unternehmen</span>
      <span class="text-sm text-gray-600">
        Ich willige ein, dass mein Kundenprofil mit weiteren Toyota-Unternehmen geteilt wird, um mir ein
        optimiertes und einheitliches Kundenerlebnis zu ermöglichen, wie in Ziff. (3) „ZWECK DER VERARBEITUNG:
        DATENWEITERGABE AN TOYOTA-UNTERNEHMEN“ der
        <a
          [href]="legalEntity.consentLink(consentVersion)"
          target="_blank"
          class="cursor-pointer underline"
        >
          vollständigen Einwilligungserklärung
        </a>
        beschrieben.
      </span>
    </span>
  </div>
</div>
